<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__employee><div class="table-default__left">Employee</div></template>
        <template #h__sales_amount>Sales<br>amount</template>
        <template #h__sales_commission>Sales<br>commission</template>
        <template #h__sales_bonus>Sales<br>bonus</template>
        <template #h__changed_amount>Changed<br>amount</template>
        <template #h__changed_commission>Changed<br>commission</template>
        <template #h__changed_bonus>Changed<br>bonus</template>
        <template #h__cancelled_amount>Cancelled<br>amount</template>
        <template #h__cancelled_commission>Cancelled<br>commission</template>
        <template #h__cancelled_bonus>Cancelled<br>bonus</template>
        <template #h__completed_amount>Completed<br>amount</template>
        <template #h__completed_commission>Completed<br>commission</template>
        <template #h__completed_bonus>Completed<br>bonus</template>
        <template #h__month_bonus>Month<br>bonus</template>
        <template #h__month_penalties>Month<br>penalties</template>
        <template #h__accrued_bonus>Accrued<br>bonus</template>
        <template #employee="{ row }">
          <div class="table-default__left">
            <router-link
              :to=" { name: 'employees-utt', params: { id: row.employee.id } }"
              class="table-default__link-border"
            >
              {{ row.employee.full_name }}
            </router-link>
          </div>
        </template>
        <template #sales_amount="{ row }">{{ parseFloat(row.leads_new_amount).toLocaleString() }}</template>
        <template #sales_commission="{ row }">{{ parseFloat(row.leads_new_commission).toLocaleString() }}</template>
        <template #sales_bonus="{ row }">{{ parseFloat(row.leads_new_rate_commission).toLocaleString() }}</template>
        <template #changed_amount="{ row }">{{ parseFloat(row.leads_changed_amount).toLocaleString() }}</template>
        <template #changed_commission="{ row }">{{ parseFloat(row.leads_changed_commission).toLocaleString() }}</template>
        <template #changed_bonus="{ row }">{{ parseFloat(row.leads_changed_rate_commission).toLocaleString() }}</template>
        <template #cancelled_amount="{ row }">{{ parseFloat(row.leads_cancelled_amount).toLocaleString() }}</template>
        <template #cancelled_commission="{ row }">{{ parseFloat(row.leads_cancelled_commission).toLocaleString() }}</template>
        <template #cancelled_bonus="{ row }">{{ parseFloat(row.leads_cancelled_rate_commission).toLocaleString() }}</template>
        <template #completed_amount="{ row }">{{ parseFloat(row.leads_completed_amount).toLocaleString() }}</template>
        <template #completed_commission="{ row }">{{ parseFloat(row.leads_completed_commission).toLocaleString() }}</template>
        <template #completed_bonus="{ row }">{{ parseFloat(row.leads_completed_rate_commission).toLocaleString() }}</template>
        <template #month_bonus="{ row }">{{ parseFloat(row.current_month_bonus).toLocaleString() }}</template>
        <template #month_penalties="{ row }">{{ parseFloat(row.current_month_penalty).toLocaleString() }}</template>
        <template #accrued_bonus="{ row }">{{ parseFloat(row.total_bonus).toLocaleString() }}</template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import { postEmployeesUTTAllowanceEmployees } from '@/http'

export default {
  name: 'AllowanceEmployee',
  data() {
    return {
      is_loaded: false,
      table: {
        items: [],
        columns: [
          'employee',
          'sales_amount',
          'sales_commission',
          'sales_bonus',
          'changed_amount',
          'changed_commission',
          'changed_bonus',
          'cancelled_amount',
          'cancelled_commission',
          'cancelled_bonus',
          'completed_amount',
          'completed_commission',
          'completed_bonus',
          'month_bonus',
          'month_penalties',
          'accrued_bonus',
        ],
        options: {
          headings: {
            employee: 'Employee',
            sales_amount: 'Sales amount',
            sales_commission: 'Sales commission',
            sales_bonus: 'Sales bonus',
            changed_amount: 'Changed amount',
            changed_commission: 'Changed commission',
            changed_bonus: 'Changed bonus',
            cancelled_amount: 'Cancelled amount',
            cancelled_commission: 'Cancelled commission',
            cancelled_bonus: 'Cancelled bonus',
            completed_amount: 'Completed amount',
            completed_commission: 'Completed commission',
            completed_bonus: 'Completed bonus',
            month_bonus: 'Month bonus',
            month_penalties: 'Month penalties',
            accrued_bonus: 'Accrued bonus',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      allowance: {},
    }
  },
  created() {
    postEmployeesUTTAllowanceEmployees(this.$route.params.id)
      .then(res => {
        this.table.items = res.data
        this.is_loaded = true
      })
  },
}
</script>
